import styled from 'styled-components';
import device from '~/config/device';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  background: var(--white);
  padding: 10px 30px;
  display: flex;
  justify-content: space-between;

  > div {
    display: flex;
    justify-content: center;

    .css-tlfecz-indicatorContainer {
      padding: 0;
    }

    @media ${device.mobileMinMobMax} {
      .css-1wa3eu0-placeholder {
        font-size: 12px;
      }
    }

    svg {
      border: 2px solid var(--yellowDark);
      padding-right: 3px;
      border-radius: 0 2px 2px 0;
      border-left: 0;
      height: 50px;
      cursor: pointer;
      color: var(--blueDark);
      margin-left: -1px;
    }

    svg.return {
      cursor: pointer;
      color: var(--blueDark);
      border: transparent;
    }

    button {
      color: var(--blueDark);
      font-weight: bold;
      font-size: 1.1rem;
      display: flex;
      align-items: center;
    }
  }
`;
